var React = require('react');

function IconArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.573 8.652l4.151 4.247c.39.4.392 1.049.004 1.45a.976.976 0 0 1-1.408.005L.79 7.672 7.316.952a.976.976 0 0 1 1.41 0c.388.4.388 1.05 0 1.45l-4.129 4.25H15.98c.447 0 .81.448.81 1s-.363 1-.81 1H4.573z","fill":"#493E54","fillRule":"nonzero"}));
}

IconArrowLeft.defaultProps = {"width":"17","height":"15"};

module.exports = IconArrowLeft;

IconArrowLeft.default = IconArrowLeft;
